import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'features.privacyPolicyModal.description',
    defaultMessage:
      'We have updated our Privacy Policy and Terms of Use. Please read and accept in order to continue using our platform.',
  },
  link: {
    id: 'features.privacyPolicyModal.link',
    defaultMessage: 'Privacy policy & Terms of use.',
  },
  title: {
    id: 'features.privacyPolicyModal.title',
    defaultMessage: 'Privacy Policy Update',
  },
});

export default messages;
